import React from 'react';

const TermsOfService = () => {
  return (
    <div className="viewer-container">
      <div className="legal-page">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using www.easycodingtools.com ("the Website"), you accept and agree to be bound by 
            the terms and provision of this agreement. If you do not agree to abide by the above, please do not 
            use this service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Easy Coding Tools provides online tools and services including but not limited to:
          </p>
          <ul>
            <li>JSON and XML validation and formatting</li>
            <li>Data comparison tools</li>
            <li>File format conversion services (PDF, Word, Excel, Images)</li>
          </ul>
        </section>

        <section>
          <h2>3. Use License</h2>
          <p>
            Permission is granted to temporarily use Easy Coding Tools for personal and commercial purposes. 
            This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose without explicit permission</li>
            <li>Attempt to reverse engineer any software contained on the Website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use the service only for lawful purposes</li>
            <li>Not upload malicious code, viruses, or harmful files</li>
            <li>Not attempt to gain unauthorized access to our systems</li>
            <li>Not use automated systems to access the service excessively</li>
            <li>Respect intellectual property rights</li>
          </ul>
        </section>

        <section>
          <h2>5. File Upload and Processing</h2>
          <p>
            When you upload files or data to our service:
          </p>
          <ul>
            <li>You retain all ownership rights to your files and data</li>
            <li>We process files in real-time and do not store them permanently</li>
            <li>You are responsible for ensuring you have the right to upload and process the files</li>
            <li>We are not responsible for any loss or corruption of data during processing</li>
          </ul>
        </section>

        <section>
          <h2>6. Service Availability</h2>
          <p>
            We strive to provide continuous availability of our services but do not guarantee uninterrupted access. 
            We reserve the right to:
          </p>
          <ul>
            <li>Modify or discontinue the service at any time</li>
            <li>Perform maintenance that may temporarily interrupt service</li>
            <li>Limit usage to prevent abuse</li>
          </ul>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            In no event shall Easy Coding Tools or its suppliers be liable for any damages (including, without 
            limitation, damages for loss of data or profit, or due to business interruption) arising out of the use 
            or inability to use the materials on Easy Coding Tools' website, even if Easy Coding Tools or an 
            authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
        </section>

        <section>
          <h2>8. Accuracy of Materials</h2>
          <p>
            The materials appearing on Easy Coding Tools' website could include technical, typographical, or 
            photographic errors. Easy Coding Tools does not warrant that any of the materials on its website 
            are accurate, complete, or current.
          </p>
        </section>

        <section>
          <h2>9. Links to Third-Party Sites</h2>
          <p>
            Easy Coding Tools has not reviewed all of the sites linked to its website and is not responsible 
            for the contents of any such linked site. The inclusion of any link does not imply endorsement by 
            Easy Coding Tools of the site.
          </p>
        </section>

        <section>
          <h2>10. Modifications</h2>
          <p>
            Easy Coding Tools may revise these terms of service for its website at any time without notice. 
            By using this website you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section>
          <h2>11. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with applicable laws. Any 
            disputes relating to these terms shall be subject to the exclusive jurisdiction of the courts in 
            the applicable jurisdiction.
          </p>
        </section>

        <section>
          <h2>12. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> legal@easycodingtools.com<br />
            <strong>Website:</strong> www.easycodingtools.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;

